export const formatName = (input: { fullName: string; short?: boolean }) => {
  const [lastName, firstName, secondName] = input.fullName.split(", ").join(" ").split(" ");
  if (input.short) {
    return `${lastName} ${firstName[0]}.`;
  }
  return `${lastName} ${firstName}`;
};

export const orderQualifierSide = <T extends { qualifier: string }>(input: T[]): T[] => {
  return input.sort((a, b) => b.qualifier.localeCompare(a.qualifier));
};

export const getPlayerSlugFromCardSlut = (str: string) => {
  const rarities = ["gold", "silver", "platinum", "common"];

  for (const rarity of rarities) {
    const index = str.indexOf(`-${rarity}-`);
    if (index !== -1) {
      return str.substring(0, index);
    }
  }

  throw new Error("No valid rarity pattern found");
};
